import { indexes } from '@mab-common/utils'

import { elasticClientFetcher } from '~/services/elastic/client'
import EsIndexTypes = indexes.EsIndexTypes

export const queryEsForNumberOfArtworks = async (artistId: string) => {
  const data = await elasticClientFetcher({
    index: EsIndexTypes.ARTWORKS,
    searches: [
      {},
      {
        size: 0,
        query: {
          bool: {
            filter: {
              term: {
                artistId: artistId,
              },
            },
          },
        },
      },
    ],
  })

  // we don't have to map here, just checking on the total count
  const numberOfArtworks = data?.[0]?.hits?.total?.value ?? 0
  return numberOfArtworks
}
